import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { UtilityService } from '../../shared/services/utility.service';

@Component({
  selector: 'app-activator-join',
  templateUrl: './activator-join.component.html',
  styleUrls: ['./activator-join.component.scss']
})
export class ActivatorJoinComponent implements OnInit, AfterViewInit, OnDestroy {
  readonly productId = 'metabology™-photonic-activator-idMETA-PA-105';
  readonly heroImage = 'https://ik.imagekit.io/fluid/980191229/ChatGPT_Image_Jul_20__2026__04_27_37_PM_-FAI8uv2v.png';
  readonly videoPoster = 'https://ik.imagekit.io/fluid/980191229/images/XTV8FG/XTV8FG_0LMO-Hni2.jpeg?updatedAt=1784761546126';
  readonly upgradeImage = 'https://ik.imagekit.io/fluid/980191229/ChatGPT_Image_Jul_20__2026__05_13_05_PM_dVm4DcSrc.png';
  readonly bottleImage = 'https://media.base44.com/images/public/6a3f3b32efa22234d833da50/ba0ac9bcf_gamefrompast1.png';

  private observer?: IntersectionObserver;
  private voomlyScript?: HTMLScriptElement;

  constructor(
    private utilityService: UtilityService,
    private host: ElementRef<HTMLElement>
  ) {}

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.utilityService.showSimplifiedheader(true);
  }

  ngAfterViewInit(): void {
    this.loadVoomly();
    this.setupRevealAnimations();
  }

  ngOnDestroy(): void {
    this.utilityService.showSimplifiedheader(false);
    this.observer?.disconnect();
    this.voomlyScript?.remove();
  }

  private loadVoomly(): void {
    document.querySelector('script[data-activator-voomly="true"]')?.remove();

    const script = document.createElement('script');
    script.src = 'https://embed.voomly.com/embed/embed-build.js';
    script.async = true;
    script.setAttribute('data-activator-voomly', 'true');
    document.body.appendChild(script);
    this.voomlyScript = script;
  }

  private setupRevealAnimations(): void {
    const elements = Array.from(
      this.host.nativeElement.querySelectorAll<HTMLElement>('[data-reveal]')
    );

    if (!('IntersectionObserver' in window)) {
      elements.forEach(element => element.classList.add('in-view'));
      return;
    }

    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          this.observer?.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

    elements.forEach(element => this.observer!.observe(element));
  }

}
